import {backdropStyles} from "@components/Popup/styles";
import React from "react";

import Fade from "../../animations/Fade";

/**
 * Overlay de-emphasizes all the background content on the screen.
 *
 * It's useful for popup boxes (desktop) and bottom sheets (mobile).
 */
const Overlay = ({open, children}: {open: boolean; children: React.ReactNode}) => {
  return (
    <Fade in={open} mountOnEnter unmountOnExit>
      <div className={`flex items-center justify-center p-0 m-0 ${backdropStyles(open)}`}>
        {children}
      </div>
    </Fade>
  );
};

export default React.memo(Overlay);
